import './bootstrap';

/* landing */
import './landing/scripts';

// validate
import './validate';

// lightbox
import './lightbox/lightbox';

// chosen
import './chosen/chosen.jquery.min';

// datepicker
import './datepicker/js/bootstrap-datepicker.min';

// wizard
import './wizard';